module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "download"
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "cover"
  }, [(_vm.page === 'download-home') ? _c('h1', [_vm._v("我们会在24小时内将供应链金融方案发至您的邮箱。")]) : _c('h1', [_vm._v("请选择以下哪种行业适用于您，"), _c('br'), _vm._v("我们会将相关的供应链金融方案发至您的邮箱。")]), _vm._v(" "), _c('portal-form', {
    attrs: {
      "from": _vm.page,
      "roleType": _vm.roleType
    }
  }), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。"), _c('br'), _vm._v("有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的"), _c('a', {
    attrs: {
      "href": "/pdf/tips.pdf",
      "download": "隐私声明"
    }
  }, [_vm._v("隐私声明")]), _vm._v("。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6ee2c3d4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/Download.vue
// module id = 1354
// module chunks = 26